// extracted by css-extract-rspack-plugin
module.exports =  {"liveTvEntry":"WDp9l","iconText":"cjeL5","liveTvColorIcon":"Y0uPH","btn":"AeT1p"};